import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { Pillar1Component } from './pages/pillar-1/pillar-1.component';
import { Pillar2Component } from './pages/pillar-2/pillar-2.component';
import { Pillar3Component } from './pages/pillar-3/pillar-3.component';
import { FelpudoComponent } from './pages/pillar-3/felpudo/felpudo.component';
import { FonaComponent } from './pages/pillar-3/fona/fona.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    title: 'Inicio', // Opcional: Título de la página
  },
  {
    path: 'pillar_1',
    component: Pillar1Component,
    title: 'Pillar 1',
  },
  {
    path: 'pillar_2',
    component: Pillar2Component,
    title: 'Pillar 2',
  },
  {
    path: 'pillar_3',
    title: 'Pillar 3',
    children: [
      {
        path: '', // Ruta vacía para redirección
        redirectTo: 'felpudo',
        pathMatch: 'full',
      },
      {
        path: 'felpudo',
        component: FelpudoComponent,
        title: 'Felpudo',
      },
      {
        path: 'fona',
        component: FonaComponent,
        title: 'Fona',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
  // Otras rutas...
];
